export const iconFontAwesomeLogisticsTruckFieldUn = (
	<i className="fa-solid fa-truck-field-un"></i>
);
